import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { ReactComponent as EmptyMessagesIcon } from '../../assets/icons/generate-ratecon.svg';

const TwDispatchNotesEmpty = (): JSX.Element => {
  return (
    <Stack className="dispatch-notes__empty" justifyContent={'center'}>
      <Box className="dispatch-notes__empty__icon">
        <EmptyMessagesIcon />
      </Box>
      <Typography fontSize={'16px'} fontWeight={500}>
        Start thread
      </Typography>
      <Typography fontSize={'14px'}>Start thread by adding your first note above</Typography>
    </Stack>
  );
};

export default TwDispatchNotesEmpty;
